import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, Outlet, useParams } from "react-router-dom";
import { SITE_ID_FETCH_SUCCESS } from "../../Reducer/SiteIdSlice";

import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css';
import API, { cancelAllRequests, createController } from "../../Network/API";
import RmsDashboardTrProps from "../../Props/RmsDashboardTrProps";
import UnlockDoorSite from "../../Models/UnlockDoorSite";
import { DOOR_DASHBOARD_FETCH_SUCCESS } from "../../Reducer/DoorDashboardSlice";
import RectifierCard from "./props/RectifierCard";
import TenantInfo from "./props/TenantInfo";
import ACPower from "./props/ACPower";
import BatteryInfo from "./props/BatteryInfo";
import { SITE_DASHBOARD_FETCH_SUCCESS } from "../../Reducer/SiteDashboardSlice";
import Agent from "../../Network/Agent";
import ReactEcharts from "echarts-for-react";
import { SITE_CODE_FETCH_SUCCESS } from "../../Reducer/siteCodeSlice";
import CountdownTimer from "../../Props/CountdownTimer";
import AcknowledgmentModel from "../../Models/AcknowledgmentModel";
import AlarmAcknowledgmentViewModal from "../../Models/AlarmAcknowledgmentViewModal";
import isTenantUser from "../../CustomHook/tenantUser";
export default function SiteDashboard() {
    const echarts_react_1 = useRef();
    const [sites, setSite] = useState()
    const [rms, setRms] = useState()
    const [temperature, setTempData] = useState()
    const [acs_alarms, setAcsAlarms] = useState([])
    const [rms_alarms, setRmsAlarms] = useState([])
    const [selectedAlarm, setSelectedAlarm] = useState(null);
    const [actionMode, setActionMode] = useState("ack");
    const [isAckModalOpen, setIsAckModalOpen] = useState(false);
    const [ackAlarmType, setAckAlarmType] = useState(1);
    const [isViewModalOpen, setIsViewModalOpen] = useState(false);
    const [viewAlarm, setViewAlarm] = useState(null);
    const [viewAlarmType, setViewAlarmType] = useState(1);

    const [modalDialog, setModalDialog] = useState(false);
    const toggleModal = () => {
        setModalDialog(!modalDialog)
    }

    const reloadSiteAlarms = () => {
        const controller = createController();
        const signal = controller.signal;
        Agent.SITE_DASHBOARD.site_info(ddd.id, signal).then((response) => {
            setRmsAlarms(response.data.data.rms_alarms);
            setAcsAlarms(response.data.data.lock_alarms);
        }).catch(() => { });
    };

    const openActionModal = (alarm, mode, type) => {
        setSelectedAlarm(alarm);
        setActionMode(mode);
        setAckAlarmType(type);
        setIsAckModalOpen(true);
    };

    const openViewModal = (alarm, type) => {
        setViewAlarm(alarm);
        setViewAlarmType(type);
        setIsViewModalOpen(true);
    };

    const stopRowClick = (event) => {
        event.stopPropagation();
    };

    const [state, setState] = useState([
        {
            startDate: new Date(),
            endDate: new Date(),
            key: 'selection'
        }
    ]);
    const ddd = useParams();
    const dispatch = useDispatch()

    useEffect(() => {

        cancelAllRequests();
        const controller = createController();
        const signal = controller.signal;

        Agent.SITE_DASHBOARD.all_sites(signal).then((response) => {
            setSite(response.data.data.sites.find(site => site.id === ddd.id))
            dispatch(SITE_CODE_FETCH_SUCCESS(response.data.data.sites));
        }).catch((error) => {

        }
        );

        Agent.SITE_DASHBOARD.site_info(ddd.id, signal).then((response) => {

            dispatch(DOOR_DASHBOARD_FETCH_SUCCESS(response.data.data.rms.site))
            setSite(response.data.data.rms.site)
            setRms(response.data.data.rms)
            setRmsAlarms(response.data.data.rms_alarms)
            setAcsAlarms(response.data.data.lock_alarms)
            dispatch(SITE_DASHBOARD_FETCH_SUCCESS({
                siteId: ddd.id,
                payload: response.data.data.rms
            }));

        }).catch((error) => {

        });

        // Agent.SITE_DASHBOARD.site_alarm_status(ddd.id, signal).then((response) => {
        //     setRmsAlarmStatus(response.data);
        // }).catch((error) => {
        // });

        Agent.SITE_DASHBOARD
            .site_temp_last_hour(ddd.id, signal)
            .then((response) => {
                setTempData(response.data.data)
            }).catch((error) => {

            });

        dispatch(SITE_ID_FETCH_SUCCESS(ddd.id))

    }, [ddd.id]);

    const option = {
        grid: {
            left: '3%',
            right: '4%',
            bottom: '5%',  // Reduce this value to make bottom space smaller
            containLabel: true
        },
        tooltip: {
            trigger: 'axis',

        },

        legend: {},
        toolbox: {
            show: false,

        },
        calculable: true,
        xAxis: [
            {
                type: 'category',
                // prettier-ignore
                data: temperature?.category
            }
        ],
        yAxis: [
            {
                type: 'value',
                axisLabel: {
                    formatter: '{value}°C'
                },
            }
        ],
        series: temperature?.value
    };

    const site_select = useSelector((state) => state.doorDashboardReducer)
    const site = site_select?.main_data
    const { user: profileUser } = useSelector((state) => state.profileReducer);
    const { user: authUser } = useSelector((state) => state.authReducer);
    const tenantUser = isTenantUser(profileUser?.id ? profileUser : authUser);
    return (
        <>
            <br />
            <div className="row px-2">
                <div className="col-md-8">
                    <div className="col-md-12">
                        <div className="card rounded-1 mb-2">
                            <div class="card-header  border-bottom card-title bg-white">
                                <a href="#" class="rms_table_heading_text">{ddd.id} (<i class={`fa fa-circle ${rms?.site?.device_live_status == 1 ? 'text-success' : 'text-danger'} `}></i> {site?.device_live_status == 1 ? 'Online' : 'Offline'})</a>
                                <p className="p-0 m-0" style={{ fontSize: '11px', color: 'blue' }}>Last Update:{rms?.update_time}</p>
                            </div>
                            <div className="tab-box1 active" id="tab1-1">
                                <table className="table table-stripedd table-bordered table-centered mb-0 text-uppercase mt-1 alarm_table_custom">
                                    <tbody>
                                        <tr>
                                            <th>Cluster</th>
                                            <td>{rms?.cluster_name}</td>
                                            <th>Zone</th>
                                            <td>{rms?.zone_name}</td>
                                            <th>Field Engineer</th>
                                            <td> {site?.master_site?.field_engineer} ({site?.master_site?.field_engineer_phone}) </td>
                                        </tr>
                                        <tr>
                                            <th>Site ID</th>
                                            <td>{site?.site_id}</td>
                                            <th>EASI SITE ID</th>
                                            <td>{site?.customer_site_id}</td>
                                            <th>Site Name</th>
                                            <td>{site?.site_name}</td>
                                        </tr>
                                        <tr>
                                            <th>Site Category</th>
                                            <td>{rms?.category_name}</td>
                                            <th>Device SN</th>
                                            <td>{rms?.device_id}</td>
                                            <th>Active SIM</th>
                                            <td>{rms?.site?.phone_number}</td>
                                        </tr>
                                        <tr>
                                            <th>IMEI</th>
                                            <td>{rms?.site?.imei}</td>
                                            <th width="20%">Hardware Version</th>
                                            <td>{rms?.site?.hardware_version}</td>
                                            <th>Firmware version</th>
                                            <td>{rms?.site?.firmware_version}</td>
                                        </tr>
                                        <tr>
                                            <th width="20%">RMS Installation</th>
                                            <td>{rms?.site?.installation_date}</td>
                                            <th>Commission date</th>
                                            <td></td>
                                            <th>PAT Date</th>
                                            <td width="20%"></td>
                                        </tr>
                                        <tr>
                                            <th>Latitude</th>
                                            <td>{rms?.site?.lat}</td>
                                            <th>Longitude</th>
                                            <td>{rms?.site?.lang}</td>
                                            <th width="20%"></th>
                                            <td>

                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Address</th>
                                            <td colSpan={5}>{rms?.site?.master_site?.address}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl-6 col-lg-6 ">
                            <div className="row">

                                <div className="card-box">
                                    <h4 className="header-title mb-0" style={{ padding: '3px', fontSize: '12px', paddingBottom: '10px' }}>Active Alarms
                                    </h4>
                                    <hr style={{ marginTop: '0px', marginBottom: '3px' }} />
                                    <ul className="nav nav-pills custom-nav-pills" role="tablist">
                                        <li className="nav-item me-2" role="presentation">
                                            <button
                                                className="nav-link nav-link-custom active"
                                                data-bs-toggle="pill"
                                                data-bs-target="#pills-active-rms"
                                                type="button"
                                                role="tab"
                                            >
                                                <i className="fa-regular fa-bell me-2"></i>
                                                RMS Alarm ({rms_alarms.length})
                                            </button>
                                        </li>

                                        {!tenantUser && (
                                        <li className="nav-item me-2" role="presentation">
                                            <button
                                                className="nav-link nav-link-custom"
                                                data-bs-toggle="pill"
                                                data-bs-target="#pills-historical-rms"
                                                type="button"
                                                role="tab"

                                            >
                                                <i className="fa-solid fa-list me-2"></i>
                                                ACS Alarm ({acs_alarms.length})
                                            </button>
                                        </li>
                                        )}
                                    </ul>
                                    <div className="tab-content p-0 m-0" id="pills-tabContent">
                                        <div className="tab-pane fade show active p-0 m-0" id="pills-active-rms" role="tabpanel" aria-labelledby="pills-active-rms-tab">
                                            <div className="table-responsive mt-2">

                                                <table className="table table-hover table-striped table-bordered mb-0  ">
                                                    <thead className="table-dark toi-primary text-white">
                                                        <tr>
                                                            <th scope="col">Site ID</th>
                                                            <th scope="col">Tenant </th>
                                                            <th scope="col">Alarm Name</th>
                                                            <th scope="col">Generated At</th>
                                                            <th scope="col">Elapsed Time</th>
                                                            <th scope="col">Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody className="">
                                                        {rms_alarms.length == 0 && (
                                                            <tr>
                                                                <td colSpan={6} className="text-center">No Active Alarms</td>
                                                            </tr>
                                                        )}
                                                        {rms_alarms.length > 0 && rms_alarms.map((alarm, index) => (
                                                            <tr
                                                                key={index}
                                                                style={{ cursor: "pointer" }}
                                                                onClick={() => openViewModal(alarm, 1)}
                                                            >
                                                                <td>{alarm.site_id}</td>
                                                                <td>{alarm.tenant_name}</td>
                                                                <td>{alarm.name}</td>
                                                                <td>{alarm.alarm_start}</td>
                                                                <td>
                                                                    {alarm.alarm_end != null ?
                                                                        <span className="elisp_time">{alarm.total_elaspsed}</span>
                                                                        :
                                                                        <CountdownTimer targetDate={alarm.alarm_start} />
                                                                    }
                                                                </td>
                                                                <td>
                                                                    {!tenantUser && (
                                                                    <div className="d-flex justify-content-center gap-2">
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-sm btn-outline-primary"
                                                                            title="Acknowledge"
                                                                            onClick={(e) => {
                                                                                stopRowClick(e);
                                                                                openActionModal(alarm, "ack", 1);
                                                                            }}
                                                                        >
                                                                            <i className="fa-light fa-check"></i>
                                                                        </button>
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-sm btn-outline-danger"
                                                                            title="Clear Alarm"
                                                                            onClick={(e) => {
                                                                                stopRowClick(e);
                                                                                openActionModal(alarm, "clear", 1);
                                                                            }}
                                                                        >
                                                                            <i className="fa-light fa-close"></i>
                                                                        </button>
                                                                    </div>
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        ))}

                                                    </tbody>
                                                </table>

                                            </div>
                                        </div>
                                        <div className="tab-pane fade p-0 m-0" id="pills-historical-rms" role="tabpanel" aria-labelledby="pills-historical-rms-tab">
                                            <div className="table-responsive mt-2">
                                                <table className="table table-hover table-striped table-bordered mb-0  ">
                                                    <thead className="table-dark toi-primary text-white">
                                                        <tr>
                                                            <th scope="col">Site ID</th>
                                                            <th scope="col">Tenant </th>
                                                            <th scope="col">Alarm Name</th>
                                                            <th scope="col">Generated At</th>
                                                            <th scope="col">Elapsed Time</th>
                                                            <th scope="col">Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody className="">
                                                        {acs_alarms.length == 0 && (
                                                            <tr>
                                                                <td colSpan={6} className="text-center">No Active Alarms</td>
                                                            </tr>
                                                        )}
                                                        {acs_alarms.length > 0 && acs_alarms.map((alarm, index) => (
                                                            <tr
                                                                key={index}
                                                                style={{ cursor: "pointer" }}
                                                                onClick={() => openViewModal(alarm, 2)}
                                                            >
                                                                <td>{alarm.site_id}</td>
                                                                <td>{alarm.tenant_name}</td>
                                                                <td>{alarm.name}</td>
                                                                <td>{alarm.alarm_start}</td>
                                                                <td>
                                                                    {alarm.alarm_end != null ?
                                                                        <span className="elisp_time">{alarm.total_elaspsed}</span>
                                                                        :
                                                                        <CountdownTimer targetDate={alarm.alarm_start} />
                                                                    }
                                                                </td>
                                                                <td>
                                                                    {!tenantUser && (
                                                                    <div className="d-flex justify-content-center gap-2">
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-sm btn-outline-primary"
                                                                            title="Acknowledge"
                                                                            onClick={(e) => {
                                                                                stopRowClick(e);
                                                                                openActionModal(alarm, "ack", 2);
                                                                            }}
                                                                        >
                                                                            <i className="fa-light fa-check"></i>
                                                                        </button>
                                                                        {(alarm.alarm_type == 6 || alarm.alarm_type == 1) && (
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-sm btn-outline-danger"
                                                                                title="Clear Alarm"
                                                                                onClick={(e) => {
                                                                                    stopRowClick(e);
                                                                                    openActionModal(alarm, "clear", 2);
                                                                                }}
                                                                            >
                                                                                <i className="fa-light fa-close"></i>
                                                                            </button>
                                                                        )}
                                                                    </div>
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        ))}

                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                            <div className="row">


                                <BatteryInfo rms={rms} />
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-6">
                            <div className="card-box" style={{ marginBottom: '10px' }}>
                                <h4 className="header-title mb-0" style={{ padding: '3px', fontSize: '12px', paddingBottom: '10px' }}>DC Power Parameter
                                </h4>
                                <hr style={{ marginTop: '0px', marginBottom: '3px' }} />
                                <table className="table table-striped table-bordered table-centered mb-0 text-uppercase mt-1 alarm_table_custom">
                                    <thead className="toi-primary text-white">
                                        <tr>
                                            <th className="text-left">Source</th>
                                            <th className="text-center">Voltage</th>
                                            <th className="text-center">Temperature</th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {rms?.dc_energy_meter.length > 0 && rms?.dc_energy_meter.map((tenant, index) => (
                                            <tr>
                                                <td className="text-left fw-medium">{tenant.tenant_name}</td>
                                                <td className="text-center">
                                                    {tenant?.voltage} V
                                                </td>
                                                <td className="text-center">
                                                    {tenant?.temperature} °C
                                                </td>
                                            </tr>

                                        ))}

                                        <tr>
                                            <td className="text-left fw-medium">Total Current</td>
                                            <td className="text-center fw-bold">
                                                {rms?.dc_current} A
                                            </td>
                                            <td></td>
                                        </tr>

                                    </tbody>
                                </table>
                            </div>
                            <TenantInfo rms={rms} />
                            <div className="card-box" style={{ marginBottom: '10px' }}>
                                <h4 className="header-title mb-0" style={{ padding: '3px', fontSize: '12px', paddingBottom: '10px' }}>Energy Consumption
                                    (Today)</h4>
                                <hr style={{ marginTop: '0px', marginBottom: '3px' }} />
                                <table className="table table-striped table-bordered table-centered mb-0 text-uppercase mt-1 alarm_table_custom">
                                    <thead className="toi-primary text-white">
                                        <tr>
                                            <th className="text-left fw-bold">Tenant Name</th>
                                            <th className="text-center fw-bold">Grid Hour <br />(HH:MM:SS)</th>
                                            <th className="text-center fw-bold">Battery Hour <br />(HH:MM:SS)</th>
                                            <th className="text-center fw-bold">PG Hour <br />(HH:MM:SS)</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="text-left fw-semibold">Grid Power</td>
                                            <td className="text-center fw-semibold">{rms?.grid_run_hour}</td>
                                            <td className="text-center fw-semibold">{rms?.battery_run_hour}</td>
                                            <td className="text-center fw-semibold">00:00:00</td>
                                        </tr>

                                    </tbody>
                                </table>
                            </div>
                            {rms?.acm?.length > 0 && rms?.acm?.map((row, index) => (
                                <ACPower key={index} row={row} />
                            ))}


                        </div>
                    </div>

                </div>

                <div className="col-md-4">

                    {!tenantUser && (
                    <div className="row mb-1">
                        <div className="card-box" style={{ marginBottom: '10px' }}>
                            <h4 className="header-title mb-0" style={{ padding: '3px', fontSize: '12px', paddingBottom: '10px' }}>Access Information
                            </h4>
                            <hr style={{ marginTop: '0px', marginBottom: '3px' }} />

                            {/* // 3 grid need here, Door,Lock, Vibration */}

                            <div className="row mt-2">
                                <div className="col-4 text-center">
                                    <div className="grid-icon ">
                                        <div className={`ion_box  ${site?.door_status==1?'bg-warning shadow-purple':'bg-green  shadow-green '} text-white justify-content-center mx-auto mb-2`}>
                                            <i className="fa-solid fa-door-open fa-2x mb-2 fs-2"></i>
                                        </div>
                                        <p className="mb-0" style={{ fontSize: '12px' }}>Door Open</p>
                                    </div>
                                </div>
                                <div className="col-4 text-center">
                                    <div className="grid-icon">
                                        <div className={`ion_box  ${site?.lock_open_status==1?'bg-warning shadow-purple':'bg-green  shadow-green '} text-white justify-content-center mx-auto mb-2`}>
                                            <i className="fa-solid fa-lock fa-2x mb-2"></i>
                                        </div>
                                        <p className="mb-0" style={{ fontSize: '12px' }}>Lock Open</p>
                                    </div>
                                </div>
                                <div className="col-4 text-center">
                                    <div className="grid-icon">
                                        <div className={`ion_box  ${site?.vib_sens_status==1?'bg-warning shadow-purple':'bg-green  shadow-green '} text-white justify-content-center mx-auto mb-2`}>
                                            <i className="fa-sharp-duotone fa-solid fa-bell-on fa-2x"></i>
                                        </div>
                                        <p className="mb-0" style={{ fontSize: '12px' }}>Vibration</p>
                                    </div>
                                </div>
                                {/* // unlock button in center  */}

                                <div className="col-12 text-center mt-2">
                                    <button className="btn btn-primary btn-sm" onClick={toggleModal}>
                                        <i className="fa-solid fa-unlock me-2"></i>Unlock Door
                                    </button>
                                    <UnlockDoorSite isModalVisible={modalDialog} handleShowB={() => setModalDialog(false)} site_id={site?.site_id} />
                                </div>
                            </div>


                        </div>
                    </div>
                    )}

                    <div className="row mb-1">
                        <div className="card-box card-temp" >
                            <h4 className="header-title mb-0 fs-7">Last 1 Hour Temperature
                            </h4>
                            <hr />
                            <div>
                                <ReactEcharts lazyUpdate={true} notMerge={true} ref={echarts_react_1} style={{ height: "240px" }} option={option} />
                            </div>
                        </div>
                    </div>




                    <div className="row mb-1">
                        <div className="card-box" style={{ marginBottom: '10px' }}>
                            <h4 className="header-title mb-0" style={{ padding: '3px', fontSize: '12px', paddingBottom: '10px' }}>AC Power Parameter</h4>
                            <hr style={{ marginTop: '0px', marginBottom: '3px' }} />
                            <table className="table table-striped table-bordered table-centered mb-0  mt-1 alarm_table_custom">
                                <thead className="toi-primary text-white">
                                    <tr>
                                        <th className="text-center">Phase</th>
                                        <th className="text-center" width="15%">Active</th>
                                        <th className="text-center" width="15%">Missing</th>
                                        <th className="text-center" width="15%">Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className="text-center" style={{ background: 'red', color: '#f9f7f7', fontWeight: 'bold' }}>R</td>
                                        <td className="text-center">
                                            <div className={`alarm_icon  ${rms?.portConfiguration?.unknown_1 == '' ? 'A4' : 'A1'} `} title=" Active ">&nbsp;</div>
                                        </td>
                                        <td className="text-center">
                                            <div className={`alarm_icon  ${rms?.unknown_1 == 0 ? 'A1' : 'A3'} `} title=" Active ">&nbsp;</div>
                                        </td>
                                        <td className="text-center">
                                            <div className={`alarm_icon  ${rms?.unknown_1 == 0 ? 'A1' : 'A3'} `} title=" Active ">&nbsp;</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="text-center" style={{ background: 'yellow', color: '#000', fontWeight: 800 }}>Y</td>
                                        <td className="text-center">
                                            <div className={`alarm_icon  ${rms?.portConfiguration?.unknown_2 == '' ? 'A4' : 'A1'} `} title=" Active ">&nbsp;</div>
                                        </td>
                                        <td className="text-center">
                                            <div className={`alarm_icon  ${rms?.unknown_2 == 0 ? 'A1' : 'A3'} `} title=" Active ">&nbsp;</div>
                                        </td>
                                        <td className="text-center">
                                            <div className={`alarm_icon  ${rms?.unknown_2 == 0 ? 'A1' : 'A3'} `} title=" Active ">&nbsp;</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="text-center" style={{ background: 'blue', color: '#fff', fontWeight: 800 }}>B</td>
                                        <td className="text-center">
                                            <div className={`alarm_icon  ${rms?.portConfiguration?.unknown_3 == '' ? 'A4' : 'A1'} `} title=" Active ">&nbsp;</div>
                                        </td>
                                        <td className="text-center">
                                            <div className={`alarm_icon  ${rms?.unknown_3 == 0 ? 'A1' : 'A3'} `} title=" Active ">&nbsp;</div>
                                        </td>
                                        <td className="text-center">
                                            <div className={`alarm_icon  ${rms?.unknown_3 == 0 ? 'A1' : 'A3'} `} title=" Active ">&nbsp;</div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                    </div>

                    <div className="row">
                        <div>


                            { !tenantUser && rms?.rectifer?.length > 0 && rms?.rectifer?.map((row, index) => (
                                <>
                                    <RectifierCard row={row} />

                                    <div className="card-box d-none" style={{ marginBottom: '10px' }}>
                                        <h4 className="header-title mb-0" style={{ padding: '3px', fontSize: '12px', paddingBottom: '10px' }}>Rectifier Alarm ({row.rectifier_name})
                                        </h4>
                                        <hr style={{ marginTop: '0px', marginBottom: '3px' }} />
                                        <table className="table table-striped table-bordered table-centered mb-0 text-uppercase mt-1 alarm_table_custom">
                                            <thead className="toi-primary text-white">
                                                <tr>
                                                    <th className="text-center">Alarm Name</th>
                                                    <th className="text-center">Generated At</th>
                                                    <th className="text-center">Elapsed Time</th>
                                                    <th className="text-center">Status</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <RmsDashboardTrProps title={`Mains Fail`} startDate={rms?.aviation_light_fault_time} status={rms?.aviation_light_fault} />
                                                <RmsDashboardTrProps title={`Dc Low`} startDate={rms?.aviation_light_fault_time} status={rms?.aviation_light_fault} />
                                                <RmsDashboardTrProps title={`Rectifier Fault`} startDate={rms?.aviation_light_fault_time} status={rms?.aviation_light_fault} />
                                                <RmsDashboardTrProps title={`LLVD`} startDate={rms?.odc_temp_high_time} status={rms?.odc_temp_high} />
                                            </tbody>
                                        </table>
                                    </div>

                                </>
                            ))}
                        </div>
                    </div>

                </div>




            </div >

            {selectedAlarm && (
                <AcknowledgmentModel
                    isModalVisible={isAckModalOpen}
                    handleShowB={() => setIsAckModalOpen(false)}
                    alarm={selectedAlarm}
                    type={ackAlarmType}
                    mode={actionMode}
                    onSuccess={reloadSiteAlarms}
                />
            )}

            {viewAlarm && (
                <AlarmAcknowledgmentViewModal
                    isOpen={isViewModalOpen}
                    onClose={() => setIsViewModalOpen(false)}
                    alarm={viewAlarm}
                    type={viewAlarmType}
                />
            )}

        </>

    )
}